// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cvC7","option":"styles_option__2VMNj","selected":"styles_selected__doY_w"};